import { EBlockedDatesStateStatus, IDatesState } from '../models/campaigns.model';
import { Action, createReducer, on } from '@ngrx/store';
import {
  changePage,
  changePageSuccess,
  createDate,
  createDateError,
  createDateSuccess,
  deleteDate,
  deleteDateError,
  deleteDateSuccess,
  loadBlockedDates,
  loadBlockedDatesError,
  loadBlockedDatesSuccess,
} from '../actions/campaigns.action';

const initialState: IDatesState = {
  items: [],
  status: EBlockedDatesStateStatus.INITIALIZING,
  error: null,
  pagination: {
    current_page: 0,
    has_more_data: false,
    has_previous: false,
    page_size: 10,
    total_pages_count: 0,
  },
  extra_data: [],
};

const datesReducer = createReducer(
  initialState,
  on(loadBlockedDates, (state, { pagination }) => {
    return {
      ...state,
      status: EBlockedDatesStateStatus.LOADING,
      pagination: {
        ...state.pagination,
        pagination,
      },
    };
  }),
  on(
    loadBlockedDatesSuccess,
    (
      state,
      {
        items,
        current_page,
        has_more_data,
        has_previous,
        page_size,
        total_pages_count,
        extra_data,
      },
    ) => {
      return {
        ...state,
        status: EBlockedDatesStateStatus.READY,
        items,
        current_page,
        has_more_data,
        has_previous,
        page_size,
        total_pages_count,
        extra_data,
      };
    },
  ),
  on(loadBlockedDatesError, (state, { error }) => {
    return {
      ...state,
      state: EBlockedDatesStateStatus.ERROR,
      error,
    };
  }),
  on(changePage, (state, { page, campaign_type }) => {
    return {
      ...state,
      status: EBlockedDatesStateStatus.READY,
      pagination: {
        ...state.pagination,
        [campaign_type]: {
          ...state.pagination[campaign_type],
          current_page: page,
        },
      },
    };
  }),
  on(changePageSuccess, (state, { campaign_type, items, pagination }) => {
    return {
      ...state,
      status: EBlockedDatesStateStatus.READY,
      [campaign_type]: items,
      pagination: {
        ...state.pagination,
        ...pagination,
      },
    };
  }),

  on(createDate, state => {
    return {
      ...state,
      status: EBlockedDatesStateStatus.LOADING,
    };
  }),
  on(createDateSuccess, (state, { response }) => {
    return {
      ...state,
      status: EBlockedDatesStateStatus.CRATED,
      update_response: response,
    };
  }),
  on(createDateError, (state, { error }) => {
    return {
      ...state,
      status: EBlockedDatesStateStatus.ERROR,
      error,
    };
  }),
  on(deleteDate, (state, { dates }) => {
    return {
      ...state,

      status: EBlockedDatesStateStatus.LOADING,
    };
  }),
  on(deleteDateSuccess, (state, { response }) => {
    return {
      ...state,
      status: EBlockedDatesStateStatus.UPDATED,
      update_response: response,
    };
  }),
  on(deleteDateError, (state, { error }) => {
    return {
      ...state,
      status: EBlockedDatesStateStatus.ERROR,
      error,
    };
  }),
);

export function reducer(state: IDatesState, action: Action) {
  return datesReducer(state, action);
}
